/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        version="1.1"
        width="20"
        height="18"
        viewBox="0 0 20 18"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          d="M20 18h-2a1 1 0 01-1-1V8a1 1 0 011-1h2zM.17 10.88a2 2 0 01-.17-.8V9a2 2 0 012-2h5.5l-.92-4.65a1 1 0 01.08-.66A4.8 4.8 0 017.54.47L8 0l6.41 6.41A2 2 0 0115 7.83v7.83A2.34 2.34 0 0112.66 18h-8.1a2 2 0 01-1.72-1z"
          className="icon-fill"
          fillRule="evenodd"/>
      </svg>
    );
  }
}

Icon.displayName = 'FacebookLikeFillIcon';

export default Icon;
